import PropTypes from 'prop-types';

const WorkroomType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip_code: PropTypes.string,
  phone_number: PropTypes.string,
  accounting_id: PropTypes.string.isRequired,
  inventory_id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
});

export default WorkroomType;



// WEBPACK FOOTER //
// ./client/app/shared/types/workroom.js